import { useEffect } from "react";

import { captureException } from "@sentry/react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { CrashError } from "./CrashError";

/**
 * Error element for a React Router route.
 *
 * React Router catches errors thrown while rendering a route's subtree, and
 * errors thrown by its loaders and actions, so they never reach the Sentry
 * error boundary at the app root. Report them to Sentry here before showing
 * the crash page.
 */
export function RouteCrashError() {
  const error = useRouteError();

  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      captureException(
        new Error(`Route error response: ${error.status} ${error.statusText}`),
        {
          extra: {
            status: error.status,
            statusText: error.statusText,
            data: error.data,
          },
        }
      );
    } else if (error instanceof Error) {
      captureException(error);
    } else {
      captureException(new Error("Unknown route error"), {
        extra: { error: String(error) },
      });
    }
  }, [error]);

  return <CrashError />;
}
